import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Card, CardContent, Typography, Box, Button } from "@mui/material";
import { FaArrowLeft } from "react-icons/fa";
import CreateDelivery from "./CreateDelivery";

const DeliveryOptions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { customer } = location.state || {}; // Get customer details from state

  const [showCreateDelivery, setShowCreateDelivery] = useState(false); // State to toggle CreateDelivery view

  if (!customer) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h6" color="error">
          No customer data found. Redirecting...
        </Typography>
        {setTimeout(() => navigate("/"), 2000)} {/* Redirect to home */}
      </Box>
    );
  }

  const handleToggleCreateDelivery = () => {
    setShowCreateDelivery(!showCreateDelivery);
  };

  const handleViewDeliveryHistory = () => {
    navigate("/delivery-history", { state: { customer } });
  };
  const handleGoToInvoiceGenerator = () => {
    navigate("/invoice-generator", { state: { customer } });
  };

  return (
    <Container maxWidth="sm" sx={{ py: 2 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <FaArrowLeft
          onClick={() => navigate(-1)} // Go back to the previous page
          style={{ cursor: "pointer", marginRight: "8px" }}
        />
        <Typography variant="h6">
          Delivery Options for {customer.name}
        </Typography>
      </Box>

      {/* Customer Details */}
      <Card variant="outlined" sx={{ marginBottom: "16px" }}>
        <CardContent>
          <Typography variant="h6">{customer.name}</Typography>
          <Typography variant="body2" color="textSecondary">
            Mobile: {customer.mobile}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Address: {customer.address}
          </Typography>
        </CardContent>
      </Card>

      {/* Toggle CreateDelivery Form */}
      {showCreateDelivery ? (
        <Box sx={{ marginBottom: "16px" }}>
          <CreateDelivery customer={customer} /> {/* Pass customer as a prop */}
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleToggleCreateDelivery}
            sx={{ marginTop: "16px" }}
          >
            Cancel
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleToggleCreateDelivery}
          >
            Create New Delivery
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleViewDeliveryHistory}
          >
            View Delivery History
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleGoToInvoiceGenerator} // Navigate to Invoice Generator
          >
            Generate Invoice
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default DeliveryOptions;
